<ng-container *ngIf="transactions$ | async as transactions">
  <ng-container *ngIf="transactions$ | async as transactions">
    <div *ngFor="let day of transactions | keyvalue: keepOrder">
      <h5 class="transaction-date text-white">{{ day.key }}</h5>
      <div class="card" *ngFor="let transaction of day.value">
        <div class="col-8 text-start">
          <div class="fw-bold transaction-text text-white font-size-14">
            {{ transaction.TransactionDescription }}
          </div>

          <div class="transaction-subtext text-white">
            {{ transaction.TransactionDateUTC | UtcToLocaltimePipe: 'hh:mm a' | uppercase }}
          </div>
        </div>
        <div class="col-4 text-end">
          <div
            class="fw-bold transaction-text text-capitalize"
            [ngClass]="transaction.Amount >= 0 ? 'text-success' : 'text-danger'"
          >
            {{ transaction.Amount >= 0 ? '+' : ''
            }}{{ transaction.Amount | FortressCurrencyPipe: (transactionType === transactionTypes.loyalty ? 'PTS' : 'USD') }}
          </div>
        </div>
      </div>
    </div>

    <ng-container *ngIf="(!transactions || !hasTransactions) && transactionType === transactionTypes.loyalty">
      <div class="placeholder-box font-size-12 text-center border rounded">
        <p class="text-center font-size-12">{{ 'account.activity.placeholder.list.description' | translate }}</p>
      </div>
    </ng-container>
    <ng-container *ngIf="(!transactions || !hasTransactions) && transactionType === transactionTypes.ecash">
      <div class="placeholder-box font-size-12 text-center border rounded">
        <p class="text-center font-size-12">{{ 'account.activity.placeholder.list.description' | translate }}</p>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
<div *ngIf="loading" class="mt-4">
  <fgbcl-loading></fgbcl-loading>
</div>
